import React, { useRef, useState } from 'react';
import './Form.css';
import emailjs from 'emailjs-com';
import { Waveform } from '@uiball/loaders';

const Form = () => {
  const form = useRef();
  const [emailSend, setEmailSend] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    setLoading(true);

    emailjs.sendForm('service_oncq9kn', 'template_oke93y2', form.current, 'xH4gp7-jmfk8QNUV7')
      .then((result) => {
        console.log(result.text);
        setEmailSend(true);
      })
      .catch((error) => {
        console.log(error.text);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className='form'>
      <form ref={form} onSubmit={sendEmail}>

        <label>Your Name</label>
        <input type="text" name='user_name' />

        <label>Email</label>
        <input type="text" name='user_email' />

        <label>Subject</label>
        <input type="text" name='subject' />

        <label>Message</label>
        <textarea rows='6' placeholder='Type your message here' name='message' />

        <button className='btn'>Submit</button>

        {loading && (<div className='waveform'>
          <Waveform />
        </div>)}
        <div className='message'>
        {emailSend && <p>Email has been sent!</p>}
        </div>
      </form>
    </div>
  );
}

export default Form;
